import { useEffect, useState } from "react";
import "./scss/QuizResults.scss"
import "./scss/Poll.scss"

function QuestionResults({questions}) {
	return (<div>
		{questions.map(element=>{
			return (<div key={element.id} className="poll poll__app">
			{element.question && <div className="poll__header" dangerouslySetInnerHTML={{ __html: element.question }} />}
				<div className="mtop--10 flex flex--column">
					{element?.options.map(({id, text, isSelected, isCorrect, isProblem}) => {
						let className = "poll__element";
						if(isSelected) className += " isSelected";
						if(isCorrect) className += " isCorrect";
						if(isProblem) className += " isProblem";
						return (<div key={id} className={className}>
							<div className="status"></div>
							{(isCorrect || isProblem) && <span className="material-icons mright--10">{isCorrect?"check":"close"}</span>}
							<span className="vm--align">{text}</span>
						</div>)
					})}
				</div>
			</div>)
		})}
	</div>);
}

const LOREAL_LOSE_MESSAGES = {
	"collagen-lifter": <div style={{ fontSize: 24, paddingBottom: 20, backgroundColor: 'white' }}>
			Thank you for playing! <br/><br/>
			Μπορεί το σκορ να μην ήταν τέλειο, αλλά τουλάχιστον τώρα ξέρεις το απόλυτο μυστικό όγκου!
	</div>,
	"elvive-hydra": <div style={{ fontSize: 24, paddingBottom: 20, backgroundColor: 'white' }}>
			Thank you for playing! <br/><br/>
			Μπορεί το σκορ να μην ήταν τέλειο, αλλά τουλάχιστον τώρα ξέρεις το απόλυτο μυστικό ενυδάτωσης!
	</div>,
};

const LOREAL_WIN_MESSAGES = {
	"haircare": <div style={{ fontSize: 24, paddingBottom: 20, backgroundColor: 'white' }}>
		Συγχαρητήρια! Κέρδισες μία <b style={{ color: '#d4242b' }}>detangling brush</b>! <br/><br/>
		Ετοιμάσου για μαλλιά χωρίς κόμπους και full λάμψη!
	</div>,
	"skincare": <div style={{ fontSize: 24, paddingBottom: 20, backgroundColor: 'white' }}>
		Congrats! Κέρδισες ένα <b style={{ color: '#d4242b' }}>beauty hair band</b>! <br/><br/>
		Γιατί κάθε beauty ρουτίνα χρειάζεται το τέλειο αξεσουάρ!
	</div>,
	"makeup": <div style={{ fontSize: 24, paddingBottom: 20, backgroundColor: 'white' }}>
		Συγχαρητήρια! Κέρδισες ένα <b style={{ color: '#d4242b' }}>mini mirror</b>! <br/><br/>
		Γιατί το τέλειο look χρειάζεται πάντα τον καλύτερό του σύμμαχο! 
	</div>,
	"collagen-lifter": <div style={{ fontSize: 24, paddingBottom: 20, backgroundColor: 'white' }}>
		Boom! Τα πέτυχες όλα! Είσαι officially expert στο Collagen Lifter και τα μαλλιά σου σε ευχαριστούν ήδη! <br/><br/>
		Κέρδισες ένα μοναδικό δώρο από τη L’Oréal Paris!
	</div>,
	"elvive-hydra": <div style={{ fontSize: 24, paddingBottom: 20, backgroundColor: 'white' }}>
		Boom! Τα πέτυχες όλα! Είσαι officially expert στο Hydra Hyaluronic και τα μαλλιά σου σε ευχαριστούν ήδη! <br/><br/>
		Κέρδισες ένα μοναδικό δώρο από τη L’Oréal Paris!
	</div>,

};

function QuizResults({data, getQuizResults, campaignId}) {
	const marginTop = data.marginTop;
	const background = data.background;
	const showCorrectQuestionCount = data.showCorrectQuestionCount;
	const preHtml = data.preHtml;
	const postHtml = data.postHtml;
	const html = data.html;
	const showCorrectAnswers = data.showCorrectAnswers;
	const [quizData, setQuizData] = useState(null);
	const scoreMultiplier = (campaignId==="8lCLlBXDE42NqpSIBZIn")?9.5:1;

	const isLorealHack = 
		window.location.pathname.includes("rbS2JkgfXoFpOzUDOpAB") || // debug id
		window.location.pathname.includes("9zMyWeDeD19cbYV52OLb") || // LOREAL haircare
		window.location.pathname.includes("wMXOHi5JrXHqY3OwgS2x") || // LOREAL skincare
		window.location.pathname.includes("ohsQBNUi8vu05L98amEI") || // LOREAL makeup
		window.location.pathname.includes("MDoztL72kJIrIBO8jc4S") || // LOREAL elvive-hydra
		window.location.pathname.includes("2WqG90WU0tqu5IRDr4hV"); // LOREAL collagen-lifter

	let lorealCare = "collagen-lifter";
	if(window.location.pathname.includes("9zMyWeDeD19cbYV52OLb")) lorealCare = "haircare";
	else if(window.location.pathname.includes("wMXOHi5JrXHqY3OwgS2x")) lorealCare = "skincare";
	else if(window.location.pathname.includes("ohsQBNUi8vu05L98amEI")) lorealCare = "makeup";
	else if(window.location.pathname.includes("2WqG90WU0tqu5IRDr4hV")) lorealCare = "collagen-lifter";
	else if(window.location.pathname.includes("MDoztL72kJIrIBO8jc4S")) lorealCare = "elvive-hydra";

	useEffect(()=>{
		getQuizResults()
		.then((data)=>{
			setQuizData(data);
		})
		.catch((error)=>{
			console.error(error);
			setQuizData(null);
		})
	}, [getQuizResults]);

	return (
		<div className="QuizResults" style={{marginTop, background, padding: "5px"}}>
			{quizData && !isLorealHack && <>
				{showCorrectQuestionCount && <div className="countContainer">
					<span dangerouslySetInnerHTML={{__html: preHtml}}></span>
					<span className="count">&nbsp;{quizData?.counts?.correct*scoreMultiplier} / {quizData?.counts?.questions*scoreMultiplier}&nbsp;</span>
					<span dangerouslySetInnerHTML={{__html: postHtml}}></span>
				</div>}
				<div className="message" dangerouslySetInnerHTML={{__html: html}}></div>
				{showCorrectAnswers && <QuestionResults questions={quizData.questions}/>}
			</>}

			{ isLorealHack && quizData &&
				<div> 
					<div className="countContainer" style={{ marginTop: 40, fontSize: 24, textAlign: 'center' }}>
						<span>Απάντησες σε </span>
						<b className="count">&nbsp;{quizData?.counts?.correct} / {quizData?.counts?.questions}&nbsp;</b>
						<span> ερωτήσεις σωστά</span>
					</div>
					{( quizData?.counts?.correct === quizData?.counts?.questions) &&
						<div className="text--center" style={{marginTop: 40, fontSize: 24, lineHeight: 1.5}}>
							<div>
								{LOREAL_WIN_MESSAGES[lorealCare]}
							</div>
						</div>
					}
					{( quizData?.counts?.correct !== quizData?.counts?.questions) &&
						<div className="text--center" style={{marginTop: 40, fontSize: 24, lineHeight: 1.5}}>
							{ LOREAL_LOSE_MESSAGES[lorealCare] || <div style={{ fontSize: 24, paddingBottom: 20, backgroundColor: 'white' }}>
									Nice Try! <br/><br/>
									Κέρδισες <b style={{ color: '#d4242b' }}>super stickers</b> από τη L’Oréal!
								</div> 
							}
						</div>
					}
				</div>
			}
			
			{!quizData && <div>Loading...</div>}
		</div>
	);
};
export default QuizResults;
